
/**
 * Automatically group consecutive product embeds into a grid.
 * No grid wrapper is required in blog content.
 */
function autoGroupWFProductEmbeds() {
  document.querySelectorAll(
    '.article-template__content, .article-content, article .rte'
  ).forEach((container) => {
    // Avoid processing the same container twice.
    if (container.dataset.wfGridProcessed === 'true') return;

    const children = Array.from(container.children);
    let group = [];

    function createGrid() {
      if (group.length < 2) {
        group = [];
        return;
      }

      const grid = document.createElement('div');
      grid.className = 'wf-product-grid';

      group[0].parentNode.insertBefore(grid, group[0]);

      group.forEach((embed) => {
        grid.appendChild(embed);
      });

      group = [];
    }

    children.forEach((child) => {
      if (child.matches('.wf-product-embed')) {
        group.push(child);
      } else {
        createGrid();
      }
    });

    createGrid();

    container.dataset.wfGridProcessed = 'true';
  });
}


class WFProductEmbed {
  constructor(element) {
    this.element = element;
    this.productUrl = element.dataset.productUrl;

    if (!this.productUrl) return;

    this.loadProduct();
  }

  getProductHandle() {
    try {
      const url = new URL(
        this.productUrl,
        window.location.origin
      );

      const parts = url.pathname.split('/products/');

      if (parts.length < 2) return null;

      return parts[1].split('/')[0];
    } catch (error) {
      return null;
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(cents / 100);
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  getDescription(description) {
    if (!description) return '';

    const temp = document.createElement('div');
    temp.innerHTML = description;

    return (temp.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  async loadProduct() {
    const handle = this.getProductHandle();

    if (!handle) {
      this.showError();
      return;
    }

    try {
      const response = await fetch(
        `/products/${encodeURIComponent(handle)}.js`
      );

      if (!response.ok) {
        throw new Error('Product could not be loaded');
      }

      const product = await response.json();
      this.render(product);

    } catch (error) {
      console.error('World Fitness Product Embed:', error);
      this.showError();
    }
  }

  render(product) {
    const productLink = `/products/${product.handle}`;

    const image =
      product.featured_image ||
      (product.images && product.images.length
        ? product.images[0]
        : '');

    const description = this.getDescription(
      product.description
    );

    let priceHTML = `
      <span class="wf-product-card__current-price">
        ${this.formatMoney(product.price)}
      </span>
    `;

    if (
      product.compare_at_price &&
      product.compare_at_price > product.price
    ) {
      const saving =
        product.compare_at_price - product.price;

      priceHTML = `
        <span class="wf-product-card__compare-price">
          ${this.formatMoney(product.compare_at_price)}
        </span>

        <span class="wf-product-card__current-price">
          ${this.formatMoney(product.price)}
        </span>

        <span class="wf-product-card__saving">
          Save ${this.formatMoney(saving)}
        </span>
      `;
    }

    this.element.innerHTML = `
      <article class="wf-product-card">

        <a
          href="${productLink}"
          class="wf-product-card__image-link"
          aria-label="${this.escapeHtml(product.title)}"
        >
          ${
            image
              ? `
                <img
                  src="${this.escapeHtml(image)}"
                  alt="${this.escapeHtml(product.title)}"
                  class="wf-product-card__image"
                  loading="lazy"
                  decoding="async"
                >
              `
              : ''
          }
        </a>

        <div class="wf-product-card__content">

          ${
            product.vendor
              ? `
                <div class="wf-product-card__vendor">
                  ${this.escapeHtml(product.vendor)}
                </div>
              `
              : ''
          }

          <h3 class="wf-product-card__title">
            <a href="${productLink}">
              ${this.escapeHtml(product.title)}
            </a>
          </h3>

          ${
            description
              ? `
                <div class="wf-product-card__description-wrap">
                  <div class="wf-product-card__description">
                    ${this.escapeHtml(description)}
                  </div>

                  <button
                    type="button"
                    class="wf-product-card__toggle"
                    aria-expanded="false"
                  >
                    View More
                  </button>
                </div>
              `
              : ''
          }

          <div class="prcwthbtn">
          <div class="wf-product-card__price">
            ${priceHTML}
          </div>

          <a
            href="${productLink}"
            class="wf-product-card__button"
          >
            VIEW PRODUCT
          </a>

          </div>

        </div>

      </article>
    `;

    const descriptionElement = this.element.querySelector(
      '.wf-product-card__description'
    );

    const toggle = this.element.querySelector(
      '.wf-product-card__toggle'
    );

    if (descriptionElement && toggle) {
      // Show the toggle only if the description needs truncation.
      requestAnimationFrame(() => {
        if (
          descriptionElement.scrollHeight <=
          descriptionElement.clientHeight + 2
        ) {
          toggle.hidden = true;
        }
      });

      toggle.addEventListener('click', () => {
        const expanded =
          toggle.getAttribute('aria-expanded') === 'true';

        descriptionElement.classList.toggle(
          'is-expanded',
          !expanded
        );

        toggle.setAttribute(
          'aria-expanded',
          String(!expanded)
        );

        toggle.textContent = expanded
          ? 'View More'
          : 'View Less';
      });
    }
  }

  showError() {
    this.element.innerHTML = '';
    this.element.hidden = true;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  autoGroupWFProductEmbeds();

  document.querySelectorAll('.wf-product-embed').forEach(
    (element) => {
      new WFProductEmbed(element);
    }
  );
});

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.wf-product-embed').forEach(
//     (element) => {
//       new WFProductEmbed(element);
//     }
//   );
// });
